module.exports = __webpack_public_path__ + "img/code.eaf6b9be.png";